import makeRequest from '../helpers/makeRequest';
// Оставим для сохранения "архитектуры"
export const loadCameras = (path, onData) => makeRequest(path, onData);
